import { lazyWithRetry } from "@js/utils/lazy-with-retry";

export const ECPViewContentLazy = lazyWithRetry(async () => {
  const module = await import(
    /* webpackChunkName: "ecp-view" */ "../../components/ecp-view-content"
  );
  return { default: module.ECPViewContent };
});
